import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantSameResidencePage = {
  alert: {
    error: 'coapplicant-same-residence-page.form.alert.error',
  },
  footer: {
    root: 'coapplicant-same-residence-page.footer.root',
  },
  form: {
    h1: 'coapplicant-same-residence-page.form.h1',
    h2: 'coapplicant-same-residence-page.form.h2',
    housingAmountInput:
      'coapplicant-same-residence-page.form.housing-amount-input',
    housingAmountInputError:
      'coapplicant-same-residence-page.form.housing-amount-input-error',
    root: 'coapplicant-same-residence-page.form.root',
    submitButton: 'coapplicant-same-residence-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
